import React from 'react';
import { useDispatch } from 'react-redux';
import { useSessionContext } from 'contexts/session';
import { routeConstants } from 'routes';
import { logOutRequest } from 'store/App';
import { getCurrentUserRequest } from 'store/User';
import AuthService from '../../lib/AuthService';
import Alert from './Alert';

const AlertTimeout: React.FC = () => {
  const dispatch = useDispatch();
  const { session, setSession } = useSessionContext();
  const timeRemaining = AuthService.timeRemainingDisplay();
  const logout = (message: string) => dispatch(logOutRequest(`${routeConstants.public.login}?message=${message}`));

  // Refresh the users token and close the modal
  const refreshToken = () => {
    if (!AuthService.isTokenExpired(AuthService.getToken())) {
      dispatch(getCurrentUserRequest()); // make request to refresh the token
      setSession({ ...session, isWarningPeriod: false }); // reset the warning period. This will close the modal.
    } else {
      logout('session_expired'); // token is already expired, cannot be refreshed
    }
  };

  return (
    <>
      {session?.isWarningPeriod && (
        <Alert
          title={`Session ending ${timeRemaining}`}
          message="You've been inactive for a while. For your security, you will be automatically logged out."
          onLeftAction={() => logout('logged_out')}
          onRightAction={refreshToken}
          leftActionLabel="Log Out"
          rightActionLabel="I'm still here"
          isActive
        />
      )}
    </>
  );
};

export default AlertTimeout;
